import { render, staticRenderFns } from "./options-general.vue?vue&type=template&id=66907894&"
import script from "./options-general.vue?vue&type=script&lang=js&"
export * from "./options-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports